// extracted by mini-css-extract-plugin
export default {"secondaryColor":"#374152"};